import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import Section from 'components/common/Section';
import AppContext from 'context/Context';
import React, { useContext } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Typewriter } from 'react-simple-typewriter';
import {
  getImageUrlFromConfigsByKey,
  getConfigFromConfigsByKey,
  getEffectiveUrl
} from 'y4/Falcon';
import _ from 'lodash';

const Hero = ({ configs }) => {
  const {
    config: { isDark, isRTL }
  } = useContext(AppContext);

  const i_bg = getImageUrlFromConfigsByKey(configs, 'LandingHeroBackground');
  const content = getConfigFromConfigsByKey(configs, 'LandingHeroContent');
  const style = _.get(content, 'extension.content.style');
  const i_dark = getEffectiveUrl(
    _.get(content, 'extension.content.banner.dark')
  );
  const i_light = getEffectiveUrl(
    _.get(content, 'extension.content.banner.light')
  );
  const tb = _.get(content, 'extension.content.topButton');
  const bb = _.get(content, 'extension.content.bottomButton');
  const text = _.get(content, 'extension.content.text');

  return (
    <Section
      className="py-0 overflow-hidden light"
      position="center bottom"
      image={i_bg}
      overlay
    >
      <Row className="justify-content-center align-items-center pt-8 pt-lg-10 pb-lg-9 pb-xl-0">
        {!style || style == 'Default' ? (
          <>
            <Col
              md={11}
              lg={8}
              xl={4}
              className="pb-7 pb-xl-9 text-center text-xl-start"
            >
              {tb && (
                <Button
                  as={Link}
                  variant="outline-danger"
                  className="mb-4 fs--1 border-2 rounded-pill"
                  to={tb.url}
                >
                  <span className="me-2" role="img" aria-label="Gift">
                    {tb.emoji}
                  </span>
                  {tb.text}
                </Button>
              )}
              {text && (
                <h1 className="text-white fw-light">
                  {text.begin}{' '}
                  <span className="fw-bold">
                    <Typewriter
                      words={text.words}
                      loop={false}
                      cursor={!isRTL ? true : false}
                      cursorStyle="|"
                      typeSpeed={70}
                      deleteSpeed={50}
                      delaySpeed={1000}
                    />
                  </span>
                  <br />
                  {text.end}
                </h1>
              )}
              {text && (
                <p className="lead text-white opacity-75">{text.with}</p>
              )}
              {bb && (
                <Button
                  as={Link}
                  variant="outline-light"
                  size="lg"
                  className="border-2 rounded-pill mt-4 fs-0 py-2"
                  to={bb.url}
                >
                  {bb.text}
                  <FontAwesomeIcon
                    icon="play"
                    transform="shrink-6 down-1 right-5"
                  />
                </Button>
              )}
            </Col>
            <Col
              xl={{ span: 7, offset: 1 }}
              className="align-self-end mt-4 mt-xl-0"
            >
              <Link to="/" className="img-landing-banner">
                <img
                  className="img-fluid"
                  src={isDark ? i_dark : i_light}
                  alt=""
                />
              </Link>
            </Col>
          </>
        ) : null}
      </Row>
    </Section>
  );
};

Hero.propTypes = {
  configs: PropTypes.array
};

export default Hero;
